(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('.sale-bar');
    if (!bar) return;

    var endTime = new Date(bar.dataset.endDatetime).getTime();
    if (isNaN(endTime)) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function update() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        bar.remove();
        clearInterval(interval);
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var daysGroup = bar.querySelector('[data-unit="days"]')?.closest('.sale-bar__timer-group');
      var daysEl = bar.querySelector('[data-unit="days"]');
      var hoursEl = bar.querySelector('[data-unit="hours"]');
      var minutesEl = bar.querySelector('[data-unit="minutes"]');
      var secondsEl = bar.querySelector('[data-unit="seconds"]');

      if (daysGroup) daysGroup.style.display = days > 0 ? '' : 'none';
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    update();
    var interval = setInterval(update, 1000);
  });
})();
